"use client";

import { ImageIcon } from "lucide-react";
import { useRef } from "react";

import { Tooltip } from "@/components/tooltip-content";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

type ImageUploadProps = {
  onImageSelect: (images: File[]) => void;
  accept?: string;
  disabled?: boolean;
  multiple?: boolean;
};

export function ImageUpload({
  onImageSelect,
  accept = "image/*",
  disabled,
  multiple = false,
}: ImageUploadProps) {
  const fileInputRef = useRef<HTMLInputElement>(null);

  const handleButtonClick = () => {
    fileInputRef.current?.click();
  };

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const files = event.target.files;
    if (files && files.length > 0) {
      const fileArray = Array.from(files);
      onImageSelect(fileArray);
      if (fileInputRef.current) {
        fileInputRef.current.value = "";
      }
    }
  };

  return (
    <div>
      <Input
        type="file"
        ref={fileInputRef}
        onChange={handleFileChange}
        accept={accept}
        className="hidden"
        aria-label="Upload image"
        multiple={multiple}
      />

      <Tooltip title="Photos/Videos">
        <Button
          disabled={disabled}
          type="button"
          size="icon"
          variant="ghost"
          onClick={handleButtonClick}
        >
        <ImageIcon className="md:h-5 md:w-5 h-4 w-4" />
        <span className="sr-only">Add image</span>
        </Button>
      </Tooltip>
    </div>
  );
}
